import { useState, useEffect, useContext, useRef, useCallback } from "react";
import * as XLSX from 'xlsx';
import { policyConfiguration } from "../../../api/automation/policy_configuration_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
//import { DataTable } from "../../../components/data_table/dataTable.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import handleNextBtnClick from "../../../components/side_menu/overlay_side_menu.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, BrandVariants, TableCellLayout, Card, Image, Input, RadioGroup, Radio, Checkbox, Label, Textarea, Dropdown, useId, Option, Switch, Tooltip, Body2, ProgressBar, Spinner } from "@fluentui/react-components";
import { AddSquare20Regular, SaveCopy20Regular, Delete20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, CalendarClock20Regular, Wand20Regular, SettingsCogMultiple20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, DismissSquare24Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, Save20Regular, Info20Filled, Dismiss16Regular, CheckmarkLock20Regular, AlertBadge20Regular, BrainCircuit20Regular, Info16Filled, ArrowUpload20Regular } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Checked } from "../../../components/switch/switch.component";
import { Inputs } from "../../../components/textarea/input.component";
import { Intent } from "../../../components/messagebar/messagebar.component";
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { fullscreenIcon, primaryIcon, secondaryIcon, exitIcon, messageTheme, lightTheme, inputsizestyle, deleteIcon, overflowDivider, buttonContent, dividerWidthStyle, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import convert from 'xml-js';
import { RadioGroups } from "../../../components/radio_group/radioGroup.component";
import type { ButtonProps, DropdownProps } from "@fluentui/react-components";
import { MultipleSelectToString } from "../../../components/form-components/MultipleSelectToString";
import { MultiselectWithTags } from "../../../components/dropdown/multiselect.component";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { ToggleSwitch } from "../../../components/form-components/toggleSwitch.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { SecurityPages } from "../../../components/side_menu/InlineSidenav";

export const Policy_config = (props: Partial<DropdownProps>) => {
	const dropdownId = useId("dropdown-default");
	const navigate = useNavigate();
	const contextValue: any = useContext(GlobalContext);
	const dartNo: any = contextValue.dartNo;
	if (dartNo != 2000) {
		localStorage.setItem('dartNo', '2000');
		contextValue.setDartNo(2000);
	}
	const tenantName = contextValue.tenantName;
	var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
	const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const formRef = useRef(null);

	const [final_data, set_final_data]: any = useState(null);
	const [tableData, setTableData] = useState([]);
	const [leftOpen, setLeftOpen] = useState(false);
	const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
	const [overlayOpen, setOverlayOpen] = useState(false);
	const [overlayName, setOverlayName] = useState('');
	const [searchVal, setSearchVal] = useState("");
	const [filterArray, setFilterArray] = useState<string[]>([]);
	const [dropDownValue1, setDropDownValue1] = useState<any>();
	const [dropDownValue2, setDropDownValue2] = useState<any>();
	const [dropDownValue3, setDropDownValue3] = useState<any>([]);
	const [dropDownValue4, setDropDownValue4] = useState<any>([]);
	const [isfilter, setIsFilter] = useState(false);
	const [filterMenuOpen, setFilterMenuOpen] = useState(false);
	const [isResetDisabled, setResetDisabled] = useState(true);
	const [totalPages, setTotalPages] = useState(1);
	const [currentPageNo, setCurrentPageNo] = useState(1);
	const [totalRecords, setTotalRecords] = useState(0);
	const [isdeletedisabled, setDeleteDisabled] = useState(true);
	const [activeTab, setActiveTab] = useState('Introduction');
	const [dartSpecs, setDartSpecs]: any = useState([]);
	const [automationOverLayData, setAutomationOverLayData]: any = useState([]);
	const [jsonSchema, setJsonData]: any = useState({});
	const [uiSchema, setUiData]: any = useState({});
	const [required, setRequired]: any = useState(true);
	const [formData, setFormData]: any = useState({
		name: '',
		description: '',
		jsonData: '',
		category: [],
		subCategory: []
	});
	const [formEditedData, setFormEditedData]: any = useState({
		name: '',
		description: '',
		jsonData: '',
		category: [],
		subCategory: [],
	});
	const [deleteAutomation, setDeleteAutomation]: any = useState(false);
	const [isRefresh, setRefresh]: any = useState(false);
	const [refreshToast, setRefreshToast]: any = useState(false);
	const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
	const [rowID, setRowID]: any = useState(1);
	const [isToast, setIsToast] = useState(false);
	const [automationSatus, setAutomationSatus] = useState('');
	const [errorToast, setErrorToast] = useState(false);
	const [toastMessage, setToastMessage] = useState('');
	const [categorySearchVal, setCategorySearchVal] = useState("");
	const [policySearchVal, setPolicySearchVal] = useState("");
	const [categorySearchData, setCategorySearchData] = useState([]);
	const [policySearchData, setPolicySearchData] = useState([""]);
	const [varvalues, setVarvalues]: any = useState("{asdf}");
	const [saveConfig, setSaveConfig]: any = useState(false);
	const [isRender, setRender]: any = useState(false);
	const [spinnerLoad, setSpinnerLoad] = useState(true);
	// const [editComponentEnable,setEditComponentEnable]:any =useState(false);
	const [exportBtnClicked, setExportBtnClicked] = useState(false);
	const [adml, setAdmlData] = useState(`
    <stringTable>
      <string id="L_AllowCamera">Loading</string>
    </stringTable>
  `);

	const [admx, setAdmxData] = useState(`
  <policy name="L_AllowCamera" class="Machine" displayName="$(string.L_AllowCamera)" explainText="$(string.L_AllowCameraExplain)" key="software\Policies\Microsoft\Camera" valueName="AllowCamera">
        <parentCategory ref="L_Camera_GroupPolicyCategory" />
        <supportedOn ref="windows:SUPPORTED_Windows_10_0" />
        <enabledValue>
            <decimal value="1" />
        </enabledValue>
        <disabledValue>
            <decimal value="0" />
        </disabledValue>
    </policy>
  `);
	const [dartid, setdartid] = useState(null);
	const [userInput, setUserInput]: any = useState({});
	const [filterColumnsData, setFilterColumnsData] = useState([])
	const [tableColumnsData, setTableColumnsData] = useState([])


	const [csvAutomationList, setCsvAutomationList] = useState<any>([]);
	const [dataInserted, setDataInserted] = useState<any>(false);
	const [error, setError] = useState('');
	const [isImportProgressLoading, setIsImportProgressLoading] = useState(false);
	const [isCommonToast, setIsCommonToast] = useState(false);
	const [message, setMessage] = useState<{ type: 'success' | 'error' | 'warning' | ''; text: string } | null>(null);
	const [importAutomations, setImportAutomations] = useState(false);
	const [isSubmitDisabled, setSubmitDisabled] = useState(false);
	const [isSubmitClicked, setSubmitClicked] = useState(false);
	const [overLayDataNew, setOverLayDataNew] = useState<any>({});
	const [selectedValue, setSelectedValue] = useState(0);
	const [overlayOpenNew, setOverlayOpenNew] = useState(false);
	const [selectedFile, setSelectedFile] = useState<any>();
	const [disableConfirmBtn, setDisableConfirmBtn] = useState(false);
	const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
	const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
	const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
	const [isStatus, setStatus] = useState<any[]>([]);
    const [errorMessage, setErrorMessage] = useState<String>('')

	useEffect(() => {
		setStatus(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
		setCreatedBy(uniqueCreatedBy?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
	}, [uniqueStatus, uniqueCreatedBy])

	useEffect(() => {
		// Direct, simple filtering
		const matchingData = final_data?.filter(
		  item => 
			contextValue?.selectedRowIdInTable.includes(item.id) && 
			item.status !== "not attached"
		) || [];
	  
		// Set disable state based on matching data
		setDisableConfirmBtn(matchingData.length > 0);
	  }, [contextValue?.selectedRowIdInTable]);

	useEffect(() => {
		setFormData({ ...formData, jsonData: userInput })
		overlayName === "editAutomation" && setFormEditedData({ ...formEditedData, jsonData: userInput })
	}, [userInput]);

	const handleFilterArray = (): any => {
		const value1 = dropDownValue1;
		const value2 = dropDownValue2;
		const result = value1 + " : " + value2;
		setFilterArray([...filterArray, result])
		setIsFilter(true);
		setLoading(true);
		setDropDownValue1('');
		setDropDownValue2('');
	}

	const [exportData, setExportData] = useState([]);
	const [exportDetails, setExportDetails]: any = useState([]);
	const [classificationNameValidation, setClassificationNameValidation]: any = useState(true);
	const [selectedAutomation, setSelectedAutomation] = useState('');
	const [selectedOption, setSelectedOption]: any = useState('');
	const { permissions } = usePermissionStore();
	const [loading, setLoading] = useState(true);
	const [cloneForm, setCloneForm] = useState<any>({});


	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const selectedFile = event.target.files?.[0];
		console.log('selectedFile - ', selectedFile?.name);
		setSelectedFile(selectedFile);
		if (!selectedFile) return;
	
		// Check if the file is a CSV by MIME type or extension
		if (selectedFile.type !== "text/csv" && !selectedFile.name.endsWith(".csv")) {
			setError("Please upload a CSV file");
			return;
		} else {
			setError(""); // Clear error if the file is valid
			setSubmitDisabled(false);
		}
	
		const reader = new FileReader();
		reader.onload = async (e: ProgressEvent<FileReader>) => {
			if (!e.target?.result) return;
	
			const data = new Uint8Array(e.target.result as ArrayBuffer);
			const workbook = XLSX.read(data, { type: 'array' });
	
			// Assuming you want to process the first sheet
			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const jsonData: (string | number)[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
	
			// Define required headers and their order
			const requiredHeaders = [
				'ID',
				'DartID',
				'Name',
				'Type',
				'Description',
				'category',
				'subCategory',
				'jsonValue',
				'varValues',
			];
	
			// Get headers from the first row and normalize them
			const headers = (jsonData[0] as string[]).map(header =>
				header?.toString().trim().toLowerCase()
			);
	
			// Find missing headers
			const missingHeaders = requiredHeaders.filter(
				requiredHeader => !headers.includes(requiredHeader.toLowerCase())
			);
	
			if (missingHeaders.length > 0) {
				setError(`Missing required columns: ${missingHeaders.join(', ')}`);
				setSubmitDisabled(true);
				return;
			}
	
			// Get index of Type column
			const typeColumnIdx = headers.findIndex(
				header => header === 'type'
			);
	
			// Get index of jsonValue column
			const jsonValueColumnIdx = headers.findIndex(
				header => header === 'jsonvalue'
			);
	
			// Filter to only include rows with type "Policy"
			const filteredData = jsonData.filter((row, index) => {
				if (index === 0) return true; // Keep headers
	
				// Check if row exists and has any values
				if (!row || Object.values(row).every(val => val === null || val === undefined || val === '')) {
					return false;
				}
	
				// Check type only if it exists
				const typeValue = row[typeColumnIdx]?.toString().toLowerCase();
				return typeValue.toLowerCase() === 'policy';
			});
	
			if (filteredData.length <= 1) { // If only headers remain
				setError("No rows with type 'Policy' found in the file");
				setSubmitDisabled(true);
				return;
			}
	
			// Check for empty jsonData in jsonValue column
			const missingJsonDataRows: number[] = [];
			filteredData.forEach((row, index) => {
				if (index === 0) return; // Skip header row
	
				try {
					const jsonValue = JSON.parse(row[jsonValueColumnIdx] as string);
					if (!jsonValue.jsonData) {
						missingJsonDataRows.push(index);
					}
				} catch (error) {
					console.error(`Error parsing jsonValue in row ${index}:`, error);
					missingJsonDataRows.push(index);
				}
			});
	
			if (missingJsonDataRows.length > 0) {
				setError(`jsonData is missing in rows: ${missingJsonDataRows.join(', ')}`);
				setSubmitDisabled(true);
				return;
			}
	
			// Create a mapping of required headers to their column indices
			const columnMapping = requiredHeaders.reduce((mapping, header) => {
				const index = headers.findIndex(h => h === header.toLowerCase());
				mapping[header] = index;
				return mapping;
			}, {} as Record<string, number>);
	
			// Reorder the data according to required header sequence
			const updatedData = filteredData.map((row, rowIndex) => {
				if (rowIndex === 0) return requiredHeaders; // Use required headers as first row
	
				return requiredHeaders.map(header =>
					row[columnMapping[header]]
				);
			});
	
			console.log('Imported Data - ', updatedData); // Process and display the updated data
			console.log('Imported Data type - ', typeof updatedData); // Process and display the updated data
			setCsvAutomationList(updatedData);
		};
	
		reader.readAsArrayBuffer(selectedFile);
	};
	

	  const handleImportSubmit = () => {
		setImportAutomations(true); setSubmitDisabled(true); setSubmitClicked(true); setIsImportProgressLoading(true);
		// Add your submit logic here
		// For example, you might call an API to submit the data
		// After submission, you can set dataInserted to true
	  };
	  
	const handleCloneData = (ids: any) => {
		if (cloneForm[`${ids}`] === undefined || cloneForm[`${ids}`]?.length < 100) {
			if (cloneForm[`${ids}`] === undefined) {
				setCloneForm({ ...cloneForm, [`${ids}`]: [{ id: Date.now(), data: {} }] });
			} else {
				setCloneForm({ ...cloneForm, [`${ids}`]: [...cloneForm[`${ids}`], { id: Date.now(), data: {} }] });
			}
		}
	};

	const handleRemoveCloneData = (admx_id: any, id: any) => {
		setCloneForm({ ...cloneForm, [`${admx_id}`]: cloneForm[`${admx_id}`].filter((formMonthlyDate: any) => formMonthlyDate.id !== id) })
	};

	useEffect(() => {
		overlayName !== "editAutomation" && setSelectedOption(formData.jsonData.polValue);
	}, [formData])

	// useEffect(() => {
	//   console.log("formData=",formEditedData);

	//   setSelectedOption(formEditedData.jsonData.polValue);
	//   console.log("formediteddata",formEditedData.jsonData)

	// }, [formEditedData])

	var admxData = '<policies>' + admx + '</policies>';
	var admlData = '<resources>' + adml + '<resources>';

	var polArr: any = [];
	// var polVal:any=[];
	var polObj: any = {};
	var regKeyValue: any = {};

	var elementsToRender: any = {};
	var policyString: any = {};

	var options = { ignoreComment: true, alwaysChildren: true, compact: true };
	var admxJson: any = convert.xml2js(admxData, options);
	var admlJson: any = convert.xml2js(admlData, options);

	var admxObj = admxJson?.policies?.policy;
	var admlObj = admlJson?.resources?.stringTable;

	var admxArr = Array.isArray(admxObj) ? admxObj : admxObj === undefined ? [] : [admxObj];
	var admlArr = Array.isArray(admlObj) ? admlObj : admlObj === undefined ? [] : [admlObj];

	admxArr?.map((admx: any) => {
		regKeyValue = {};
		var keyNvalue: any = {};
		var compType: any = {};
		var listRegPath: any = {};
		var displayString = admx?._attributes.displayName.match(/\.(.*?)\)/);
		var displayName = displayString ? displayString[1] : "";
		var classValue = admx?._attributes.class;
		var regPath = admx?._attributes.key;
		var admx_valueName = admx?._attributes.valueName;
		admlArr?.map((adml: any) => {
			var admlString = Array.isArray(adml?.string) ? adml?.string : [adml?.string];

			admlString.map((ID: any) => {
				var admlID = ID?._attributes.id;
				if (admlID === displayName) {
					policyString = ID?._text;

					if (admx_valueName) {
						let key = "Default";
						var itemVal: any;

						if (admx.enabledValue) {
							if (admx?.enabledValue?.hasOwnProperty('string')) {
								itemVal = admx?.enabledValue?.string?._text;
								dataType = "string";
							} else if (admx.enabledValue.hasOwnProperty('decimal')) {
								itemVal = admx?.enabledValue?.decimal?._attributes?.value;
								dataType = "decimal";
							}

							keyNvalue = { ...keyNvalue, [`${"enabledValue"}`]: { ...keyNvalue[`${"enabledValue"}`], [`${admx_valueName}`]: itemVal } };
							compType = { ...compType, [`${"Default"}`]: { ...compType[`${"Default"}`], [`${admx_valueName}`]: dataType } };
						}

						if (admx.disabledValue) {
							if (admx?.disabledValue?.hasOwnProperty('string')) {
								itemVal = admx?.disabledValue?.string?._text;
							} else if (admx.disabledValue.hasOwnProperty('decimal')) {
								itemVal = admx?.disabledValue?.decimal?._attributes?.value;
							}
							keyNvalue = { ...keyNvalue, [`${"disabledValue"}`]: { ...keyNvalue[`${"disabledValue"}`], [`${admx_valueName}`]: itemVal } };
						}

						if (Object.keys(regKeyValue).length > 0) {
							regKeyValue[key] = [...regKeyValue[`${key}`], [admx_valueName]];
						} else {
							regKeyValue[key] = [admx_valueName];
						}
						elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${admx_valueName}`]: '' } };
					}

					if (admx.enabledList) {
						var elementArray: any = [];
						var dataType: any;
						var itemVal: any;
						let key = "enabledList";
						var enableItems = Array.isArray(admx.enabledList.item) ? admx.enabledList.item : [admx.enabledList.item];

						enableItems.map((item: any) => {
							if (item.value.hasOwnProperty('decimal')) {
								itemVal = item?.value?.decimal?._attributes.value;
								dataType = "decimal";
							} else if (item.value.hasOwnProperty('string')) {
								itemVal = item.value.string._text;
								dataType = "string";
							}

							regPath = item?._attributes?.key;
							admx_valueName = item?._attributes.valueName;
							keyNvalue = { ...keyNvalue, [`${"enabledList"}`]: { ...keyNvalue[`${"enabledList"}`], [`${admx_valueName}`]: itemVal } };
							keyNvalue = { ...keyNvalue, [`${"enabledListRegPath"}`]: { ...keyNvalue[`${"enabledListRegPath"}`], [`${admx_valueName}`]: regPath } };
							compType = { ...compType, [`${"type"}`]: { ...compType[`${"type"}`], [`${admx_valueName}`]: dataType } };
							elementArray.push(admx_valueName);
							if (!admx.disabledList) {
								keyNvalue = { ...keyNvalue, [`${"disabledList"}`]: { ...keyNvalue[`${"disabledList"}`], [`${admx_valueName}`]: "" } };
							}
						});

						if (admx.disabledList) {
							var disableItems = Array.isArray(admx.disabledList.item) ? admx.disabledList.item : [admx.disabledList.item];

							disableItems.map((item: any) => {
								if (item.value.hasOwnProperty('decimal')) {
									itemVal = item?.value?.decimal?._attributes.value;
								} else if (item.value.hasOwnProperty('string')) {
									itemVal = item.value.string._text;
								}
								admx_valueName = item?._attributes.valueName;
								keyNvalue = { ...keyNvalue, [`${"disabledList"}`]: { ...keyNvalue[`${"disabledList"}`], [`${admx_valueName}`]: itemVal } };
							});
						} else {
							keyNvalue = { ...keyNvalue, [`${"disabledList"}`]: { ...keyNvalue[`${"disabledList"}`], [`${admx_valueName}`]: "" } };
						}
						regKeyValue[key] = elementArray;
						elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${admx_valueName}`]: '' } };
					}

					if (admx.elements) {
						var key: any;
						var value: any;
						for ([key, value] of Object.entries(admx.elements)) {
							var elementArray: any = [];
							var valueListArray: any = [];
							switch (key) {
								case "text":
									var admx_arr = Array.isArray(value) ? value : [value];
									admx_arr.map((ele: any) => {
										var admx_id = ele?._attributes.id;
										var admx_valueName = ele?._attributes.valueName;
										elementArray.push(admx_valueName);
										regKeyValue[key] = elementArray;
										var textarray = Array.isArray(adml?.textBox) ? adml?.textBox : [adml?.textBox];
										const Values = textarray.find(
											(adml: any) => adml?._attributes.refId === admx_id
										);
										var textvalue = Values ? Values.label._text : null;
										var componentToRender = <Input type="text" value={userInput[`${displayName}`] != undefined && userInput[`${displayName}`][`${admx_valueName}`] != undefined ? userInput[`${displayName}`][`${admx_valueName}`] : ''} name={key} id={admx_valueName} onChange={(e: any) => { setUserInput({ ...userInput, [`${displayName}`]: { ...userInput[`${displayName}`], [`${admx_valueName}`]: e.target.value } }) }} required />;
										var componentHTML = <Stack tokens={{ childrenGap: 10 }}>
											<StackItem>
												<Stack tokens={{ childrenGap: 10 }} horizontal id={admx_valueName}>
													<StackItem> <Body1> {textvalue} </Body1> </StackItem>
													<StackItem> {componentToRender} </StackItem>
												</Stack>
											</StackItem>
										</Stack>;
										elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${admx_valueName}`]: componentHTML } };
									})
									break;
								case "boolean":
									var admx_arr = Array.isArray(value) ? value : [value];
									admx_arr.map((ele: any) => {
										var admx_id = ele?._attributes.id;
										var admx_valueName = ele?._attributes.valueName;
										elementArray.push(admx_valueName);
										if (ele._attributes.hasOwnProperty('key')) {
											var booleanRegPath = ele._attributes.key;
											keyNvalue = { ...keyNvalue, [`${"booleanRegPath"}`]: { ...keyNvalue[`${"booleanRegPath"}`], [`${admx_valueName}`]: booleanRegPath } };
										}
										if (ele.hasOwnProperty('trueValue')) {
											if (ele.trueValue.hasOwnProperty('decimal')) {
												itemVal = ele.trueValue.decimal._attributes.value;
												dataType = "decimal";
											}
											else if (ele.trueValue.hasOwnProperty('string')) {
												itemVal = ele.trueValue.string._text;
												dataType = "string";
											}
											keyNvalue = { ...keyNvalue, [`${"booleanTrueValue"}`]: { ...keyNvalue[`${"booleanTrueValue"}`], [`${admx_valueName}`]: itemVal } };
											compType = { ...compType, [`${"booleanType"}`]: { ...compType[`${"booleanType"}`], [`${admx_valueName}`]: dataType } };
										}
										if (ele.hasOwnProperty('falseValue')) {
											if (ele.falseValue.hasOwnProperty('decimal')) {
												itemVal = ele.falseValue.decimal._attributes.value;
											}
											else if (ele.falseValue.hasOwnProperty('string')) {
												itemVal = ele.falseValue.string._text;
											}
											keyNvalue = { ...keyNvalue, [`${"booleanFalseValue"}`]: { ...keyNvalue[`${"booleanFalseValue"}`], [`${admx_valueName}`]: itemVal } };
										}
										regKeyValue[key] = elementArray;
										var checkboxarray = Array.isArray(adml?.checkBox) ? adml?.checkBox : [adml?.checkBox];

										const Values = checkboxarray.find(
											(adml: any) => adml?._attributes.refId === admx_id
										);
										var checkboxvalue = Values ? Values._text : null;
										var componentToRender = <Checkbox type="checkbox" checked={userInput[`${displayName}`] != undefined && userInput[`${displayName}`][`${admx_valueName}`] != undefined ? userInput[`${displayName}`][`${admx_valueName}`] : false} name={key} id={admx_valueName} onChange={(e: any) => { setUserInput({ ...userInput, [`${displayName}`]: { ...userInput[`${displayName}`], [`${admx_valueName}`]: e.target.checked } }) }} />;
										var componentHTML = <Stack tokens={{ childrenGap: 10 }}>
											<StackItem>
												<Stack tokens={{ childrenGap: 10 }} horizontal id={admx_valueName}>
													<StackItem> <Body1> {checkboxvalue} </Body1> </StackItem>
													<StackItem> {componentToRender} </StackItem>
												</Stack>
											</StackItem>
										</Stack>;
										elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${admx_valueName}`]: componentHTML } };
									})
									break;
								case "decimal":
									var admx_arr = Array.isArray(value) ? value : [value];
									admx_arr.map((ele: any) => {
										var admx_id = ele?._attributes.id;
										var admx_valueName = ele?._attributes.valueName;
										elementArray.push(admx_valueName);
										regKeyValue[key] = elementArray;
										var numberarray = Array.isArray(adml?.decimalTextBox) ? adml?.decimalTextBox : [adml?.decimalTextBox];
										const Values = numberarray.find(
											(adml: any) => adml?._attributes.refId === admx_id
										);
										var numbervalue = Values ? Values._text : null;
										var componentToRender = <Input value={userInput[`${displayName}`] != undefined && userInput[`${displayName}`][`${admx_valueName}`] != undefined ? userInput[`${displayName}`][`${admx_valueName}`] : ''} type="number" name={key} id={admx_valueName} min="0" onChange={(e: any) => { setUserInput({ ...userInput, [`${displayName}`]: { ...userInput[`${displayName}`], [`${admx_valueName}`]: e.target.value } }) }} />;
										var componentHTML = <Stack tokens={{ childrenGap: 10 }}>
											<StackItem>
												<Stack tokens={{ childrenGap: 10 }} horizontal id={admx_valueName}>
													<StackItem> <Body1> {numbervalue} </Body1> </StackItem>
													<StackItem> {componentToRender} </StackItem>
												</Stack>
											</StackItem>
										</Stack>;
										elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${admx_valueName}`]: componentHTML } };
									})
									break;
								case "multiText":
									var admx_arr = Array.isArray(value) ? value : [value];
									admx_arr.map((ele: any) => {
										var admx_id = ele?._attributes.id;
										var admx_valueName = ele?._attributes.valueName;
										elementArray.push(admx_valueName);
										regKeyValue[key] = elementArray;
										var multiTextarray = Array.isArray(adml?.multiTextBox) ? adml?.multiTextBox : [adml?.multiTextBox];
										const Values = multiTextarray.find(
											(adml: any) => adml?._attributes.refId === admx_id
										);
										var multiTextvalue = Values ? Values._text : null;
										var componentToRender = <Textarea value={userInput[`${displayName}`] != undefined && userInput[`${displayName}`][`${admx_valueName}`] != undefined ? userInput[`${displayName}`][`${admx_valueName}`] : ''} resize="both" size="small" name={key} id={admx_valueName} onChange={(e: any) => { setUserInput({ ...userInput, [`${displayName}`]: { ...userInput[`${displayName}`], [`${admx_valueName}`]: e.target.value } }) }} />;
										var componentHTML = <Stack tokens={{ childrenGap: 10 }}>
											<StackItem>
												<Stack tokens={{ childrenGap: 10 }} horizontal id={admx_valueName}>
													<StackItem> <Body1> {multiTextvalue} </Body1> </StackItem>
													<StackItem> {componentToRender} </StackItem>
												</Stack>
											</StackItem>
										</Stack>;
										elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${admx_valueName}`]: componentHTML } };
									})
									break;
								case "enum":
									var admx_id: any;
									var textvalue: any;
									var enumobj: any = {};
									var dataType: any;
									var enumArray = Array.isArray(adml?.dropdownList) ? adml?.dropdownList : [adml?.dropdownList];
									var admx_arr = Array.isArray(value) ? value : [value];
									admx_arr.map((ID: any, index: any) => {
										var dropdown: any = [];
										var enum_valueName: any;
										admx_id = ID?._attributes.id;
										const Values = enumArray.find(
											(adml: any) => adml?._attributes.refId === admx_id
										);
										textvalue = Values ? Values._text : null;
										enum_valueName = ID?._attributes.valueName;
										var items = Array.isArray(ID.item) ? ID.item : [ID.item];
										items.map((name: any) => {
											var enumVal: any;
											if (name.value.hasOwnProperty('decimal')) {
												enumVal = name?.value?.decimal?._attributes.value;
												dataType = "decimal";
											} else if (name.value.hasOwnProperty('string')) {
												enumVal = name?.value?.string?._text;
												dataType = "string";
											}
											const displayName = name?._attributes.displayName.replace("$(string.", "").replace(")", "");
											const dropdownValues = admlString.find(
												(values: any) => values?._attributes?.id === displayName
											);
											var itemvalue = dropdownValues ? dropdownValues._text : null;
											enumobj = { ...enumobj, [itemvalue]: enumVal };
											dropdown.push(itemvalue);

											if (name.hasOwnProperty("valueList")) {
												let key = "valueList";
												var valueList = Array.isArray(name?.valueList?.item) ? name?.valueList?.item : [name?.valueList?.item];
												valueList.map((list: any) => {
													var valueListName = list._attributes.valueName;
													var valueListKey = list._attributes.key;
													if (list.value.hasOwnProperty("delete")) {
														var valueListRegValue = "delete";
													} else {
														valueListRegValue = list?.value?.decimal?._attributes?.value;
													}
													keyNvalue = { ...keyNvalue, [`${enumVal}`]: { ...keyNvalue[`${enumVal}`], [`${valueListName}`]: { [`${"valueListRegpath"}`]: valueListKey } } };

													keyNvalue = { ...keyNvalue, [`${enumVal}`]: { ...keyNvalue[`${enumVal}`], [`${valueListName}`]: { ...keyNvalue[`${enumVal}`][`${valueListName}`], [`${"valueListRegValue"}`]: valueListRegValue } } };
												})
											}
										});

										var optionKey: any = '';
										if (userInput[`${displayName}`] != undefined && userInput[`${displayName}`][`${enum_valueName}`] != undefined) {
											optionKey = Object.entries(enumobj).find(([key, value]) => value === userInput[`${displayName}`][`${enum_valueName}`])?.[0];
										}

										elementArray.push(enum_valueName);
										regKeyValue[key] = elementArray;
										compType = { ...compType, [`${"type"}`]: { ...compType[`${"type"}`], [`${enum_valueName}`]: dataType } };
										var componentToRender = <Dropdown defaultValue={optionKey} id={enum_valueName} aria-labelledby={dropdownId} placeholder="Select an option"{...props}>
											{dropdown.map((option: any, index: number) =>
												<Option key={index} value={enumobj[option]} onClick={(e: any) => { setUserInput({ ...userInput, [`${displayName}`]: { ...userInput[`${displayName}`], [`${enum_valueName}`]: enumobj[option] } }) }}>
													{option}
												</Option>
											)}
										</Dropdown>;
										var componentHTML = <Stack tokens={{ childrenGap: 10 }}>
											<StackItem>
												<Stack tokens={{ childrenGap: 10 }} horizontal id={enum_valueName}>
													<StackItem> <Body1> {textvalue} </Body1> </StackItem>
													<StackItem> {componentToRender} </StackItem>
												</Stack>
											</StackItem>
										</Stack>;
										elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${enum_valueName}`]: componentHTML } };
									});
									break;
								case "list":
									var listcount = 2;
									var listString: any;
									var listarray = Array.isArray(adml?.listBox) ? adml?.listBox : [adml?.listBox];
									admx_arr = Array.isArray(value) ? value : [value];
									admx_arr.map((ID: any) => {
										var admx_id = ID?._attributes.id;
										listRegPath = ID?._attributes.key;
										const Values = listarray.find(
											(adml: any) => adml?._attributes.refId === admx_id
										);
										var admx_valueName = "1";
										var textvalue = Values ? Values._text : null;
										elementArray.push(admx_valueName);
										regKeyValue[key] = elementArray;

										var componentToRender = <Input value={userInput[`${displayName}`] != undefined && userInput[`${displayName}`][`${admx_valueName}`] != undefined ? userInput[`${displayName}`][`${admx_valueName}`] : ''} type="text" name={key} id={admx_valueName} required onChange={(e: any) => { setUserInput({ ...userInput, [`${displayName}`]: { ...userInput[`${displayName}`], [`${admx_valueName}`]: e.target.value } }) }} />;

										var dynamicTextComponent =
											<Stack tokens={{ childrenGap: 10 }}>
												<StackItem>
													<Stack tokens={{ childrenGap: 10 }} horizontal id={admx_id}>
														<StackItem> <Body1> {textvalue} </Body1> </StackItem>
														<StackItem> {componentToRender} </StackItem>
														<Button shape="circular" size="small">
															<AddSquare20Regular {...primaryIcon} onClick={() => handleCloneData(admx_id)} />
														</Button>
													</Stack>
												</StackItem>
												{cloneForm[`${admx_id}`] != undefined ? cloneForm[`${admx_id}`].map((formMonthlyDate: any, i: any) => {
													var totalcount = listcount + i;
													listString = totalcount.toString()
													regKeyValue[key].push(listString);

													return <StackItem key={formMonthlyDate.id}>
														<Stack horizontal tokens={{ childrenGap: 10 }}>
															<StackItem>
																<Input type="text" name={key} id={i} required onChange={(e: any) => { setUserInput({ ...userInput, [`${displayName}`]: { ...userInput[`${displayName}`], [`${listcount + i}`]: e.target.value } }) }} />
															</StackItem>
															<StackItem>
																<Button shape="circular" size="small">
																	<Delete20Regular {...deleteIcon} onClick={() => handleRemoveCloneData(admx_id, formMonthlyDate.id)} />
																</Button>
															</StackItem>
														</Stack>
													</StackItem>
												}) : <></>}
											</Stack>;
										elementsToRender = { ...elementsToRender, [`${displayName}`]: { ...elementsToRender[`${displayName}`], [`${admx_valueName}`]: dynamicTextComponent } };
									});
									break;
							}
						}
					}
				}
			})
		});

		polObj = {
			name: displayName,
			polName: policyString,
			class: classValue,
			regpath: regPath,
			regkey: regKeyValue,
			keyNvalue: keyNvalue,
			listRegPath: listRegPath,
			compType: compType
		};
		polArr.push(polObj);
	});

	const handleCloseFilter = (index: any): any => {
		const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
		setFilterArray(updatedArray);
		setLoading(true);
	}

	useEffect(() => {
		if (filterArray.length > 0) {
			setResetDisabled(false)
		}
		else {
			setResetDisabled(true)
		}
	}, [filterArray])
	const handle = useFullScreenHandle();

	const buttonref: any = useRef(null);
	const handleOutsideButton = () => {
		buttonref?.current?.click();
	};
	const inputChange = (e: any) => {
		const enteredValue = e.target.value;
		console.log("entered value", enteredValue)
		let name = e.target.name;
		const regexS = /^[A-Za-z ]*$/;
		const regexSN = /^[A-Za-z0-9 ]*$/;
		const regexN = /^[0-9]*$/;
		if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
			setErrorMessage(`${dropDownValue1} is already filtered.`);
			return;
		} else {
			setErrorMessage(''); // Clear the message if no issue
		}
		if (name === 'filter' && dropDownValue1 === ("Name") || dropDownValue1 === ("Description") || dropDownValue1 === ("Status")) {
			if (regexSN.test(enteredValue)) {
				setDropDownValue2(enteredValue);
			}
		}
		if (name === 'filter' && dropDownValue1 === ("Created by")) {
			if (regexS.test(enteredValue)) {
				setDropDownValue2(enteredValue);
			}
		}
	}

	const handleSubmit = (e: any) => {
		e.preventDefault();
		// handleNextBtnClick(e);
	}

	useEffect(() => {
		setFormData({ ...formData, category: dropDownValue3 });
		overlayName === "editAutomation" && setFormEditedData({ ...formEditedData, category: dropDownValue3 });
		console.log("dropdownvalue3", dropDownValue3)
	}, [dropDownValue3])

	useEffect(() => {
		setFormData({ ...formData, subCategory: dropDownValue4 });
		overlayName === "editAutomation" && setFormEditedData({ ...formEditedData, subCategory: dropDownValue4 });
		console.log("dropdownvalue4", dropDownValue4)
	}, [dropDownValue4]);

	useEffect(() => {
		var flag = true;
		exportDetails.map((val: any) => {
			if (val.automationName === formData.name || (overlayName === 'editAutomation' && val.automationName === formEditedData.name)) {
				flag = false;
			}
		});

		if (overlayName === 'editAutomation' && formEditedData.name === selectedAutomation) {
			flag = true;
		}

		setClassificationNameValidation(flag);
	}, [formData, formEditedData, selectedAutomation]);

	const handlePolicy = () => {
		setOverlayName('addAutomation');
		setSpinnerLoad(false);
		setFormData({ name: '', description: '', jsonData: '', category: [], subCategory: [] });
		setRender(false);
		setDropDownValue3([]);
		setDropDownValue4([]);
		setTimeout(() => {
			setOverlayOpen(true);
		}, 100);
	}

	//data table column name code starts here
	// var columns = [
	//   { key: "name", label: <Body1Strong> Name </Body1Strong> },
	//   { key: "description", label: <Body1Strong> Description </Body1Strong> },
	//   { key: "created_by", label: <Body1Strong> Created by </Body1Strong> },
	//   { key: "created_on", label: <Body1Strong> Created On (UTC) </Body1Strong> },
	//   { key: "created_on", label: <Body1Strong> Created On ({formattedTimeZone}) </Body1Strong> },
	//   { key: "last_modified", label: <Body1Strong> Last Modified (UTC) </Body1Strong> },
	//   { key: "last_modified", label: <Body1Strong> Last Modified ({formattedTimeZone}) </Body1Strong> },
	//   { key: "status", label: <Body1Strong> Status </Body1Strong> },
	// ];
	//data table column name code ends here

	// var columns1 = [
	//   { key: "name", label: <Caption1> Name </Caption1> },
	//   { key: "description", label: <Caption1> Description </Caption1> },
	//   { key: "created_by", label: <Caption1> Created by </Caption1> },
	//   { key: "created_on", label: <Caption1> Created On </Caption1> },
	//   { key: "last_modified", label: <Caption1> Last Modified </Caption1> },
	//   { key: "status", label: <Caption1> Status </Caption1> },
	// ];
	var tableColumns: any[] = [];
	var filterColumns: any[] = [];
	useEffect(() => {
		contextValue?.tableColumnsData?.Automation?.Policy.forEach((val) => {
			if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
				if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
					tableColumns[val.priority] = ({
						key: val.key,
						label:
							<>
								<Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
									<StackItem>
										<Body1Strong>{`${val.name}`}</Body1Strong>
									</StackItem>
									<StackItem align="center">
										<Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
											<Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
										</Tooltip>
									</StackItem>
								</Stack>
							</>
					});
				} else {
					tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
				}
			}

			if (val.display.filter.toLocaleLowerCase() === "yes") {
				filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
			}
		});

		setTableColumnsData(tableColumns);
		setFilterColumnsData(filterColumns);

		contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Automation?.Policy.filter((val) => val.priority >= 0));

		contextValue.setManageViewPageDetails({ module: "Automation", page: "Policy" });
	}, [contextValue.tableColumnsData]);
	// overflow set contents code starts here
	var overFlowComponent = {
		data:
			<>
				{permissions.includes("all") || permissions.includes("automationCompPolicies_Fullaccess") ?

					<StackItem>
						<Button shape="circular" appearance="subtle" size="small" disabled={loading}>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem>{loading ? <AddSquare20Regular {...secondaryIcon} /> : <AddSquare20Regular {...primaryIcon} />} </StackItem>
								<StackItem> <Caption1 onClick={() => { handlePolicy() }}> Create Policy </Caption1> </StackItem>
							</Stack>
						</Button>
					</StackItem>
					:
					<StackItem>
						<Button shape="circular" appearance="subtle" size="small" disabled>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
								<StackItem> <Caption1> Create Policy </Caption1> </StackItem>
							</Stack>
						</Button>
					</StackItem>
				}

				<StackItem>
					<Divider vertical />
				</StackItem>

				<StackItem>
					<DialogBox
						headerButton={
							<>
								<Button shape="circular" appearance="transparent" size="small"
									disabled={isdeletedisabled ? true : false} >
									<Stack tokens={{ childrenGap: 5 }} horizontal>
										<StackItem>
											{/* <Delete20Regular {...primaryIcon} />  */}
											{isdeletedisabled
												? (<Delete20Regular {...secondaryIcon} />)
												: (<Delete20Regular {...primaryIcon} />)
											}
										</StackItem>
										<StackItem> <Caption1> Delete </Caption1> </StackItem>
									</Stack>
								</Button>
							</>
						}

						content={disableConfirmBtn ? "Enabled policy cannot be deleted. Please disable or unselect the enabled policy and try again." : "Please confirm if you want to proceed with deleting the policy."}

						footer=
						{
							<>
								<Stack horizontal tokens={{ childrenGap: 10 }}>
									<StackItem>
										<Button shape="circular" disabled={disableConfirmBtn} appearance="primary" onClick={() => { setDeleteAutomation(true); /*userActivity('Delete', `{"summary":"${contextValue.selectedRowIdInTable.length} policy deleted"}`);*/ }} size="small">Confirm</Button>
									</StackItem>
									<StackItem>
										<Button shape="circular" size="small">Cancel</Button>
									</StackItem>
								</Stack>
							</>
						}
					/>
				</StackItem>

				<StackItem>
					<Divider vertical />
				</StackItem>

				<StackItem>
					<Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setRefresh(true); setCurrentPageNo(1) }}>
						<Stack tokens={{ childrenGap: 5 }} horizontal>
							<StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
							<StackItem> <Caption1> Refresh </Caption1> </StackItem>
						</Stack>
					</Button>
				</StackItem>

				{permissions.includes("all") || permissions.includes("automationCompPolicies_Fullaccess") ?
					<StackItem>
						{/* <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_configurationlist.csv`}>
            </CSVLink> */}
						<Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); }}>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
								<StackItem> <Caption1> Export </Caption1> </StackItem>
							</Stack>
						</Button>
					</StackItem>
					:
					<Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
						<Button shape="circular" appearance="subtle" size="small" disabled>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem><Text></Text></StackItem>
								<StackItem>
									<Stack tokens={{ childrenGap: 5 }} horizontal>
										<StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
										<StackItem><Caption1> Export </Caption1></StackItem>
									</Stack>
								</StackItem>
							</Stack>
						</Button>
					</Tooltip>
				}

				<StackItem><Divider vertical /></StackItem>

				{permissions.includes("all") || permissions.includes("allAutomation_Fullaccess") || permissions.includes("allAutomation_Fullaccess") ?
					<StackItem>
						{/* <CSVLink id="csv-export-link" data={exportData} filename="configurationlist.csv"> */}
						<Button disabled={loading || tableData.length === 0} shape="circular" appearance="subtle" size="small" onClick={() => {
							setOverlayOpenNew(true);
							setSelectedValue(0);
							setCsvAutomationList([]);
							setDataInserted(false);
							setMessage({ type: "", text: "" })
							setSubmitClicked(false);
						}}>
							<Stack tokens={{ childrenGap: 5 }} horizontal>
								<StackItem> {loading || tableData.length === 0 ? <ArrowUpload20Regular  {...secondaryIcon} /> : <ArrowUpload20Regular  {...primaryIcon} />} </StackItem>
								<StackItem> <Caption1> Import </Caption1> </StackItem>
							</Stack>
						</Button>
						{/* </CSVLink> */}
					</StackItem>
					:
					<StackItem>
						<Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
							<Button shape="circular" appearance="subtle" size="small" disabled>
								<Stack tokens={{ childrenGap: 5 }} horizontal>
									<StackItem><Text></Text></StackItem>
									<StackItem>
										<Stack tokens={{ childrenGap: 5 }} horizontal>
											<StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
											<StackItem><Caption1> Import </Caption1></StackItem>
										</Stack>
									</StackItem>
								</Stack>
							</Button>
						</Tooltip>
					</StackItem>
				}

				<StackItem>
					<Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
						<Stack tokens={{ childrenGap: 5 }} horizontal>
							<StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
							<StackItem> <Caption1> Manage View </Caption1> </StackItem>
						</Stack>
					</Button>
				</StackItem>

				<StackItem grow shrink>
					<Stack horizontalAlign="end">
						<StackItem grow shrink>
							<FullScreenButton handle={handle} />
						</StackItem>
					</Stack>
				</StackItem>
			</>
		,
	};
	// overflow set contents code ends here

	const handleNewFormChange = (e: any) => {
		setFormData({
			...formData,
			jsonData: e.formData
		});
	}



	// formEditedData?.jsonData != "" && Object.keys(formEditedData?.jsonData?.jsonData).forEach(key => {
	//   // Check if the current key is included in polArr
	//   if (polVal.includes(key)) {
	//     // If the key is included, log polArr
	//     console.log("required poll",key)
	//   }
	//   else{
	//     // alert("nodata")
	//   }
	// });

	useEffect(() => {
		console.log("formEditedDataaaa=", formEditedData.jsonData);

		formEditedData?.jsonData != "" && setUserInput(formEditedData?.jsonData);

	}, [formEditedData, dropDownValue4]);


	const handleEditFormChange = (e: any) => {
		setFormEditedData({
			...formEditedData,
			jsonData: e.formData
		});
	}

	let exportToExcel = async () => {
		const ws = XLSX.utils.json_to_sheet(exportData);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
		XLSX.writeFile(wb, `compliance_policy_list.csv`);
	};

	var tempTableData: any = [];
	var menuLists: any = [];
	var tempExportData: any = [];

	useEffect(() => {
		var tempExportData: any = [];
		// var status = '';
		console.log('exportDetails ->', exportDetails)
		exportDetails?.length > 0 && exportDetails.map((val: any) => {
			if (val.types === 'policy') {

				tempExportData.push({
					'ID': val.id,
					'DartID': val.dartid,
					'Name': val.automationName,
					'Type': val.types.charAt(0).toLocaleUpperCase() + val.types.slice(1),
					'Description': val.description,
					'category': val.category,
					'subCategory': val.subCategory,
					'jsonValue': val.jsonValue,
					'varValues': val.varValues,
					// 'varValues': JSON.stringify(`'${val.varValues}'`),
					// 'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
					// 'Created On': val.createdOn != null ? convertToExcelFormat(val.createdOn) : '-',
					// 'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
					// 'Status': status,
				});
			}
		});

		setExportData(tempExportData);
		console.log('exportBtnClicked clicked: ' + exportBtnClicked);
		// tempExportData && exportToExcel()
	}, [exportDetails]);

	useEffect(() => {
		console.log('exportData : ' + exportData);
		exportData.length > 0 && exportToExcel();
	}, [exportData]);

	// useEffect(() => {
	//   exportData.length > 0 && document.getElementById('csv-export-link')?.click();
	// }, [exportData]);

	useEffect(() => {
		if (final_data !== undefined && final_data !== null) {
			const newUniqueCreatedBy: string[] = [];
			const newUniqueStatus: string[] = [];

			final_data?.forEach((val: any) => {
				if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
					newUniqueCreatedBy.push(val.createdBy);
				}
				if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
					newUniqueStatus.push(val.status);
				}
			});
			setUniqueCreatedBy(newUniqueCreatedBy);
			setUniqueStatus(newUniqueStatus);
			console.log("Unique Created By:", newUniqueCreatedBy);
		} else {
			setUniqueCreatedBy([]);
			setUniqueStatus([]);
		}
	}, [final_data]);
	
	useEffect(() => {
		// data table values append code starts here
		console.log("final_data=", final_data);
		var status = '';
		final_data !== undefined && final_data !== null
			? final_data.map((val: any, i: any) => {
				if (val.status == 'not attached') {
					status = 'Not attached';
				} else {
					var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

					if (curStatus.length === 0) {
						status = 'Enabled for other tenant';
					} else {
						curStatus = curStatus[0]?.split(":")[1];

						if (curStatus == 'all') {
							status = 'Enabled for All Devices';
						} else {
							status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
						}
					}
				}

				{
					permissions.includes("all") || permissions.includes("compPolicies_Fullaccess") ?
						tempTableData.push({
							id: val.id,
							checkbox: "show",
							name: {
								label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => {
									setOverlayName('editAutomation');
									const jsonValue = JSON.parse(val.jsonValue);
									const status = val.status === 'not attached' ? 'not attached' : 'attached';
									setRowID(val.id);
									setdartid(val.dartid);
									setOverlayOpen(true);
									setAutomationSatus(status);
									setSelectedAutomation(val.automationName);
									setDropDownValue3(jsonValue.category);
									setDropDownValue4(jsonValue.subCategory);
									setSpinnerLoad(true);
								}}> {val.automationName} </Button>
							},
							description: { label: <Caption1> {val.description} </Caption1>, status: "" },
							created_by: { label: <Caption1> {val.createdBy} </Caption1> },
							created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
							created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
							last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
							last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
							status: { label: <Caption1> {status} </Caption1> },
						})
						:
						tempTableData.push({
							id: val.id,
							checkbox: "hide",
							name: {
								label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
									<Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.automationName} </Button>
								</Tooltip>
							},
							description: { label: <Caption1> {val.description} </Caption1>, status: "" },
							created_by: { label: <Caption1> {val.createdBy} </Caption1> },
							created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
							created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
							last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
							last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
							status: { label: <Caption1> {status} </Caption1> },
						})
				}
			}) : (tempTableData = []);

		tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

		setTimeout(() => {
			final_data !== undefined && final_data !== null && setLoading(false);
		}, 500);
	}, [final_data, overlayOpen]);
	// data table values append code ends here

	useEffect(() => {
		if (Object.keys(jsonSchema).length > 0) {
			var varValues = Object.keys(jsonSchema?.properties);

			var tempObj: any = {};
			varValues.map((ele: any) => {
				tempObj[`${ele}`] = jsonSchema.properties[`${ele}`]?.default;
			})

			setFormData({
				...formData,
				jsonData: tempObj
			});
			setFormEditedData({
				...formEditedData,
				jsonData: tempObj
			})
		}
	}, [jsonSchema]);

	useEffect(() => {
		setDropDownValue4([]);
		setPolicySearchVal('');
		setRender(false);
	}, [dropDownValue3]);

	useEffect(() => {
		console.log("polArr=", polArr);
		if (isRender) {
			const userInput = {};

			polArr.map((item: any, cnt: any) => {
				userInput[`${item.name}`] = { policyStatus: false };
			});
			console.log("userInput=", userInput);

			setUserInput(userInput);
		}
	}, [isRender]);

	console.log("dropDownValue4.length",dropDownValue4.length);

	useEffect(() => {
		var compKeys: any = [];

		if (dartSpecs?.length > 0) {
			var details = dartSpecs.length > 0 ? dartSpecs[0].details : "{}";
			details = JSON.parse(details);

			overlayName === 'addAutomation' && setAutomationOverLayData({
				headerTitle: "Create Policy",
				size: "large",
				isTabs: true,
				tabItems: {
					Introduction: <form autoComplete="off" id="myForm" onSubmit={(e) => handleSubmit(e)}> <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
						<StackItem>
							<p> <b>Name <Image src="/Dashboard/image/required.svg" /></b></p>
						</StackItem>
						<StackItem>
							<p> <Inputs inputChange={setFormData} inputVal={formData} required={required} /></p>
							{!classificationNameValidation && <Body1>This Policy name already exists</Body1>}
						</StackItem>
						{/* {error && <StackItem>*This is required field</StackItem>} */}

						<StackItem>
							<p> <b>What does this Policy Do?</b></p>
						</StackItem>
						<StackItem>
							<p> <Resize inputChange={setFormData} inputValue={formData} /></p>
						</StackItem>

						<InfoBar title={"These are the basic details associated with this Policy."} />

						{Object.keys(details).map(key => (
							<>
								<StackItem>
									<p><b>{key}</b></p>
								</StackItem>
								<StackItem>
									<p>{details[key]}</p>
								</StackItem>
							</>
						))}
					</Stack>
						<Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
					</form>,
					Configure:
						<form id="myForm" autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
							<Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
								<Stack tokens={{ childrenGap: 4 }}>
									<Body1Strong>Category <Image src="/Dashboard/image/required.svg" /></Body1Strong>
									<StackItem><Text></Text></StackItem>
									<StackItem>
										<MultiselectWithTags style={inputsizestyle} onChange={(e: any) => { setCategorySearchVal(e.target.value) }} options={categorySearchData} setSelectedOptions={setDropDownValue3} selectedOptions={dropDownValue3} multi={false} tag={false} placeholder="Please Search" required />
									</StackItem>
								</Stack>
								<Stack tokens={{ childrenGap: 4 }}>
									<Body1Strong>Sub-Category <Image src="/Dashboard/image/required.svg" /></Body1Strong>
									<StackItem><Text></Text></StackItem>
									<StackItem>
										<MultiselectWithTags style={inputsizestyle} onChange={(e: any) => { setPolicySearchVal(e.target.value) }} options={policySearchData} setSelectedOptions={setDropDownValue4} selectedOptions={dropDownValue4} multi={false} tag={false} placeholder="Please Search" required />
									</StackItem>
								</Stack>
								{isRender && dropDownValue4.length > 0 && <Body1>
									{polArr.map((item: any, cnt: any) => {
										compKeys = Object.keys(item.regkey);
										return <>
											<Stack horizontal>
												<StackItem>
													<Text>{item.polName}</Text>
												</StackItem>
												<StackItem>
													<Switch checked={userInput[`${item.name}`]?.policyStatus} onChange={(e: any) => { setUserInput({ ...userInput, [`${item.name}`]: { ...userInput[`${item.name}`], policyStatus: e.target.checked } }) }} />
												</StackItem>
											</Stack>

											{userInput[`${item.name}`]?.policyStatus && Object.keys(elementsToRender[`${item.name}`])?.length > 0 && compKeys.map((value: any) => {
												if (value == "Default") {
													// console.log("Do not render");
													return "";
												}
												var compVal = item.regkey[value];
												// console.log("compValues=",compVal);
												return compVal.map((val: any) => <Text>{elementsToRender[`${item.name}`][`${val}`]}</Text>)
											})}
										</>
									}
									)}
								</Body1>}
							</Stack>
							<Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
						</form>
					,
					'Review Data': <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
						<StackItem>
							<p> <b>Name</b></p>
						</StackItem>
						<StackItem>
							<p> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /></p>
						</StackItem>

						<StackItem>
							<p> <b>What does this Policy Do?</b></p>
						</StackItem>
						<StackItem>
							<p> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /></p>
						</StackItem>

						<Stack tokens={{ childrenGap: 4 }}>
							<Body1Strong>Category</Body1Strong>
							<StackItem><Text></Text></StackItem>
							<StackItem>
								{dropDownValue3.length > 0 && dropDownValue3?.map((val: any) => <Badge color="informative">{val}</Badge>)}
							</StackItem>
						</Stack>
						<Stack tokens={{ childrenGap: 4 }}>
							<Body1Strong>Sub-Category</Body1Strong>
							<StackItem><Text></Text></StackItem>
							<StackItem>
								{dropDownValue4.length > 0 && dropDownValue4?.map((val: any) => <Badge color="informative">{val}</Badge>)}
							</StackItem>
						</Stack>
						{isRender && <Body1>
							{polArr.map((item: any, cnt: any) => {
								compKeys = Object.keys(item.regkey);

								return <>
									<Stack horizontal>
										<StackItem>
											<Text>{item.polName}</Text>
										</StackItem>
										<StackItem>
											<Switch checked={userInput[`${item.name}`]?.policyStatus} onChange={(e: any) => { setUserInput({ ...userInput, [`${item.name}`]: { ...userInput[`${item.name}`], policyStatus: e.target.checked } }) }} disabled={true} />
										</StackItem>
									</Stack>

									{userInput[`${item.name}`]?.policyStatus && Object.keys(elementsToRender[`${item.name}`])?.length > 0 && compKeys.map((value: any) => {
										if (value == "Default") {
											return "";
										}
										var compVal = item.regkey[value];
										return compVal.map((val: any) => <Text>{elementsToRender[`${item.name}`][`${val}`]}</Text>)
									})}
								</>
							}
							)}
						</Body1>}
					</Stack>
				},
			});

			Object.keys(formData).length > 0 && overlayName === 'editAutomation' /*&& automationSatus != 'not attached'*/ && setAutomationOverLayData({
				headerTitle: `Edit ${selectedAutomation}`,
				size: "large",
				isTabs: true,
				tabItems: {
					Introduction:spinnerLoad?
						<Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
						<Spinner/>
						</Stack>
						:<form id="myForm" autoComplete="off" onSubmit={(e) => handleSubmit(e)}>  <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
						<StackItem>
							<p> <b>Name <Image src="/Dashboard/image/required.svg" /></b></p>
						</StackItem>
						<StackItem>
							<p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} required={true} /></p>
							{!classificationNameValidation && <Body1>This automation name already exists</Body1>}
						</StackItem>

						<StackItem>
							<p> <b>What does this Policy Do?</b></p>
						</StackItem>
						<StackItem>
							<p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} /> </p>
						</StackItem>

						{Object.keys(details).map(key => (
							<>
								<StackItem>
									<p><b>{key}</b></p>
								</StackItem>
								<StackItem>
									<p>{details[key]}</p>
								</StackItem>
							</>
						))}
					</Stack>
						<Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
					</form>,

					Configure: <form id="myForm" autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
						<Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
							<Stack tokens={{ childrenGap: 4 }}><Body1>Category</Body1>
								<StackItem><Text></Text></StackItem>
								<StackItem>
									<p> <Input value={formEditedData?.category} disabled={true} /></p>
								</StackItem>
							</Stack>
							<Stack tokens={{ childrenGap: 4 }}>
								<Body1>Sub-Category</Body1>
								<StackItem><Text></Text></StackItem>
								<StackItem>
									<p> <Input value={formEditedData?.subCategory} disabled={true} /></p>
								</StackItem>
								{isRender && <Body1>
									{polArr.map((item: any, cnt: any) => {
										compKeys = Object.keys(item.regkey);
										return <>
											<Stack horizontal>
												<StackItem>
													<Text>{item.polName}</Text>
												</StackItem>
												<StackItem>
													<Switch checked={userInput[`${item.name}`]?.policyStatus} onChange={(e: any) => { setUserInput({ ...userInput, [`${item.name}`]: { ...userInput[`${item.name}`], policyStatus: e.target.checked } }) }} />
												</StackItem>
											</Stack>
											{userInput[`${item.name}`]?.policyStatus && Object.keys(elementsToRender[`${item.name}`])?.length > 0 && compKeys.map((value: any) => {
												var compVal = item.regkey[value];
												return compVal.map((val: any) => <Text>{elementsToRender[`${item.name}`][`${val}`]}</Text>)
											})}
										</>
									})}
								</Body1>}
							</Stack>
						</Stack>
						<Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
					</form>,

					'Review Data': <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
						<StackItem>
							<p> <b>Name</b></p>
						</StackItem>
						<StackItem>
							<p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} disabled={true} /></p>
						</StackItem>

						<StackItem>
							<p> <b>What does this Policy Do?</b></p>
						</StackItem>
						<StackItem>
							<p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} disabled={true} /></p>
						</StackItem>
						<Stack tokens={{ childrenGap: 4 }}>
							<Body1Strong>Category</Body1Strong>
							<StackItem><Text></Text></StackItem>
							<StackItem>
								{/* {<MultiselectWithTags style={inputsizestyle} onChange={(e: any) => setCategorySearchVal(e.target.value)} options={categorySearchData} setSelectedOptions={setDropDownValue3} selectedOptions={dropDownValue3} multi={false} tag={false} placeholder="Please Search" required disabled={true} />  } */}
								{/* {dropDownValue3.length > 0 && dropDownValue3?.map((val: any) => <Badge color="informative">{val}</Badge>)} */}
							</StackItem>
						</Stack>
						<Stack tokens={{ childrenGap: 4 }}>
							<Body1Strong>Sub-Category</Body1Strong>
							<StackItem><Text></Text></StackItem>
							<StackItem>
								{/* <MultiselectWithTags style={inputsizestyle} onChange={(e: any) => setPolicySearchVal(e.target.value)} options={policySearchData} setSelectedOptions={setDropDownValue4} selectedOptions={dropDownValue4} multi={false} tag={false} placeholder="Please Search" required disabled={true} /> */}
								{/* {dropDownValue4.length > 0 && dropDownValue4?.map((val: any) => <Badge color="informative">{val}</Badge>)} */}
							</StackItem>
						</Stack>
						{isRender && <Body1>
							{polArr.map((item: any, cnt: any) => {
								compKeys = Object.keys(item.regkey);

								return <>
									<Stack horizontal>
										<StackItem>
											<Text>{item.polName}</Text>
										</StackItem>
										<StackItem>
											<Switch checked={userInput[`${item.name}`]?.policyStatus} onChange={(e: any) => { setUserInput({ ...userInput, [`${item.name}`]: { ...userInput[`${item.name}`], policyStatus: e.target.checked } }) }} disabled={true} />
										</StackItem>
									</Stack>

									{userInput[`${item.name}`]?.policyStatus && Object.keys(elementsToRender[`${item.name}`])?.length > 0 && compKeys.map((value: any) => {
										if (value == "Default") {
											return "";
										}
										var compVal = item.regkey[value];
										return compVal.map((val: any) => <Text>{elementsToRender[`${item.name}`][`${val}`]}</Text>)
									})}
								</>
							}
							)}
						</Body1>}
					</Stack>
				},
			});
		}
	}, [dartSpecs, overlayName, formData, formEditedData, classificationNameValidation, selectedOption, policySearchData, categorySearchData, cloneForm, userInput, dropDownValue3, dropDownValue4, rowID]);

	useEffect(() => {
		setOverLayDataNew({
			size: "medium",
			isTabs: false,

			headerTitle:
				(
					<>
						<Title3>
							{'Create Policy'}
						</Title3>
					</>
				),

			bodyData:
				(
					<>
						<Stack>{isImportProgressLoading && <ProgressBar />}</Stack>
						<Stack tokens={{ childrenGap: 10 }} horizontal>
							<StackItem grow shrink>
								<Stack tokens={{ childrenGap: 10 }} horizontal>
									<StackItem grow shrink>
										<Stack tokens={{ childrenGap: 20 }} horizontalAlign="start">
											<StackItem>
												{<><Stack className={isImportProgressLoading ? 'disabled-opacity' : ''} verticalAlign="center" tokens={{ childrenGap: 10 }}>
													<Stack tokens={{ childrenGap: 10 }}>
														<StackItem><Text></Text></StackItem>

														<StackItem>
															<StackItem> <Body1> Start by exporting policy list in compliance policy page. </Body1> </StackItem>
															{/* <StackItem> <Body1> You can choose devices from the same site or different ones to create groups. </Body1> </StackItem> */}
														</StackItem>
														<StackItem><Text></Text></StackItem>
														{/* <FluentProvider theme={warningTheme}>
															<StackItem><Text>We only support for Automation, Selfhelp/Proactive, Autoheal import.</Text></StackItem>
														</FluentProvider> */}
														<StackItem><Text></Text></StackItem>

														<StackItem> <Body1Strong> Steps to import the policy </Body1Strong> </StackItem>

														<StackItem>
															<Body1> 1. Download the file that contains the list of policy </Body1>
														</StackItem>

														<Stack>
															<StackItem> <Body1> 2. check policy in the CSV. </Body1> </StackItem>
														</Stack>

														<StackItem> <Body1> 3. Upload your .csv file </Body1> </StackItem>

														<StackItem>
															{/* <FileUploadComponent setDeviceList={setCsvAutomationList} /> */}
															{/* <Button shape="circular" appearance='secondary' size='small' onClick={handleUpload}> Select a file </Button> */}
															<input /*style={{"display": "none"}} */ type="file" onChange={handleFileChange} accept='.csv' id="fileUpload" />
															{error && <p style={{ color: 'red' }}>{error}</p>}
															{/* {selectedFile?.length > 0 && <Text> File selected: {selectedFile} </Text>} */}
															{/* <button onClick={ handleFileUpload}>Upload</button> */}
														</StackItem>
													</Stack>
												</Stack>
												</>
												}
											</StackItem>
										</Stack>
									</StackItem>
								</Stack>
							</StackItem>
						</Stack>
					</>
				),

			footerData:
				(
					<>
						{
							<Button
								appearance="primary"
								disabled={
									!selectedFile || Boolean(error) || isSubmitDisabled
								}
								onClick={() => { handleImportSubmit(); }}
							>
								{isSubmitClicked! ? (
									<Stack horizontal horizontalAlign="center" verticalAlign="center" tokens={{ childrenGap: 8 }}>
										<Spinner delay={1000} size="extra-tiny" />
										<Body1Strong>Inserting</Body1Strong>
									</Stack>
								) : (
									<Body1Strong>Submit</Body1Strong>
								)}
							</Button>
						}
						{(dataInserted) && (<Badge appearance="ghost" color="success"> <Body2> Automations has been inserted successfully!</Body2> </Badge>)}
					</>
				)
		});
	}, [selectedFile, csvAutomationList, dataInserted, overlayOpenNew, isImportProgressLoading, error, isSubmitClicked, isSubmitDisabled]);

	useEffect(() => {
		console.log("submitDisabled = " + isSubmitDisabled);
		console.log("selectedFile = " + (selectedFile ? selectedFile.name : "none"));
	  }, [isSubmitDisabled, selectedFile]);

	// useEffect(() => {
	// 	!overlayOpenNew && setOverlayName('');
	// }, [overlayOpenNew]);

	useEffect(() => {
		if (saveBtnClicked) {
			setSaveConfig(true);
		} else {
			setOverlayOpen(false);
			setSaveConfig(false);
			setFormData({ name: '', description: '', jsonData: '', category: [], subCategory: [] });
			setFormEditedData({ name: '', description: '', jsonData: '', category: [], subCategory: [] });
		}
	}, [saveBtnClicked]);

	useEffect(() => {
		contextValue.setSelectedRowIdInTable([]);
	}, []);

	useEffect(() => {
		contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
	}, [contextValue.selectedRowIdInTable]);

	useEffect(() => {
		if (!overlayOpenNew) {
			setError('')
			setSubmitDisabled(true); // disable sumbit button when overlay will get closes.
		}
	}, [overlayOpenNew]);
	
	useEffect(() => {
		const pageNo = (currentPageNo - 1) * 50;

		const props: any = {
			pageNo: pageNo,
			setExportBtnClicked: setExportBtnClicked,
			formData: formData,
			overlayName: overlayName,
			overlayOpen: overlayOpen,
			saveBtnClicked: saveBtnClicked,
			setSaveBtnClicked: setSaveBtnClicked,
			setOverlayOpen: setOverlayOpen,
			setErrorToast: setErrorToast,
			setToastMessage: setToastMessage,
			setIsToast: setIsToast,
			exportBtnClicked: exportBtnClicked,
			data: final_data,
			func: set_final_data,
			searchVal: searchVal,
			setTotalPages: setTotalPages,
			setTotalRecords: setTotalRecords,
			setDartSpecs: setDartSpecs,
			setJsonData: setJsonData,
			setUiData: setUiData,
			deleteAutomation: deleteAutomation,
			setDeleteAutomation: setDeleteAutomation,
			setDeleteDisabled: setDeleteDisabled,
			isRefresh: isRefresh,
			setRefresh: setRefresh,
			setRefreshToast: setRefreshToast,
			isFilter: isfilter,
			dropDownValue1: dropDownValue1,
			setIsFilter: setIsFilter,
			dropdownValue2: dropDownValue2,
			categorySearchVal: categorySearchVal,
			categorySearchData: categorySearchData,
			setCategorySearchData: setCategorySearchData,
			policySearchVal: policySearchVal,
			setPolicySearchVal: setPolicySearchVal,
			dropDownValue3: dropDownValue3,
			setPolicySearchData: setPolicySearchData,
			policySearchData: policySearchData,
			setDropDownValue4: setDropDownValue4,
			dropDownValue4: dropDownValue4,
			setAdmxData: setAdmxData,
			setAdmlData: setAdmlData,
			varvalues: varvalues,
			setDropDownValue3: setDropDownValue3,
			setdartid: setdartid,
			dartid: dartid,
			setExportDetails: setExportDetails,
			filterArray: filterArray,
			setRender: setRender,
			setFormData: setFormData,
			rowID: rowID,
			setSaveConfig: setSaveConfig,
			setUserInput: setUserInput,
			setOverlayName: setOverlayName,
			tenant: tenantName,
			dartNo: dartNo,
			selectedRowIdInTable: contextValue.selectedRowIdInTable,
			policyArr: polArr,
			userInput: userInput,
			setLoading: setLoading,
	  		setIsImportProgressLoading: setIsImportProgressLoading,
			setMessage: setMessage,
			setIsCommonToast: setIsCommonToast,
			setImportAutomations: setImportAutomations,
			setSubmitDisabled: setSubmitDisabled,
			importAutomations: importAutomations,
			csvAutomationList: csvAutomationList,
			setCsvAutomationList: setCsvAutomationList,
			setDataInserted: setDataInserted,
			setOverlayOpenNew: setOverlayOpenNew,
		}

		if ((!saveBtnClicked && overlayName === '') || saveConfig) {
			props.newData = overlayName === 'editAutomation' ? formEditedData : formData;
			props.setFormData = overlayName === 'editAutomation' ? setFormEditedData : setFormData;
		} else if (overlayName !== '' && !saveBtnClicked) {
			props.newData = overlayName === 'editAutomation' ? formEditedData : formData;
			props.setFormData = overlayName === 'editAutomation' ? setFormEditedData : setFormData;
			props.formData = overlayName === 'editAutomation' ? formEditedData : formData;
		}

		if ((!saveBtnClicked && overlayName === '') || (overlayName !== '' && saveConfig) || (overlayName !== '' && !saveBtnClicked) || importAutomations) {
			policyConfiguration(props);
		}
	}, [deleteAutomation, isRefresh, searchVal, saveConfig, overlayName, currentPageNo, isfilter, dropDownValue3, filterArray, dropDownValue4, rowID, exportBtnClicked, importAutomations]);

	return (
		<>
			<FullScreen handle={handle} className="fullScreenBackgroundColor">
				<StackItem grow shrink style={BreadcrumbsBorder}>
					<Stack tokens={{ childrenGap: 10 }} horizontal>
						<StackItem grow shrink>
							<Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
								<StackItem><Text></Text></StackItem>
								<StackItem grow shrink>
									<Breadcrumbs
										items={[
											{ name: "Automate", link: "/home" },
											{ name: "Security", link: "" },
											{ name: "Compliance Policies", link: "" },
										]}
									/>
								</StackItem>
							</Stack>
						</StackItem>
					</Stack>
				</StackItem>
				<Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
				<StackItem style={DynamicBoxingCSS}>
					<StackItem style={DynamicBoxingCSS}>
						{/* pages code starts here */}
						<Stack style={DynamicBoxingCSS}>
							<FluentProvider style={parentHome} theme={dashboardTheme}>
								<Stack style={parentHome} horizontal >
									{/* SPACING BETWEEN INLINE AND PAGE */}
									<SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={SecurityPages(`Compliance${" "}Policies`)} />
									<StackItem style={DynamicBoxingCSS}>
										<Stack style={parentHome} tokens={{ childrenGap: 10 }}>
											<StackItem>
												<OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
												<Divider />
											</StackItem>
											<StackItem style={wraperStyle}>
												<StackItem>
													<Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
														<Stack horizontal tokens={{ childrenGap: 10 }}>
															<StackItem>
																<SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading} />
															</StackItem>
															<StackItem>
																<MenuDropdown open={filterMenuOpen} btn={
																	<MenuButton disabled={loading} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
																		<Stack tokens={{ childrenGap: 5 }} horizontal>
																			{loading ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
																			<Body1> Filter </Body1>
																		</Stack>
																	</MenuButton>} itemVal={<><Body1Strong> Add a Filter </Body1Strong>
																		<Divider />
																		<MenuList>
																			<Stack tokens={{ childrenGap: 5 }}>
																				<StackItem> <Text></Text> </StackItem>
																				<StackItem> <Caption1> Filter </Caption1> </StackItem>
																				<DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
																				<StackItem> <Divider /> </StackItem>
																				<StackItem> <Caption1> Value </Caption1> </StackItem>
																				{(dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? <span style={{ color: 'red' }}>This column is already filtered</span> : <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />)}
																				{(dropDownValue1 === 'Created By') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? <span style={{ color: 'red' }}>This column is already filtered</span> : <DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />)}																		
																				{(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Status") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? <span style={{ color: 'red' }}>This column is already filtered</span> : <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />)}
																				<StackItem><Divider /></StackItem>
																				<Stack tokens={{ childrenGap: 10 }} horizontal>
																					<StackItem>
																						<Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
																							disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
																							<Caption1> Apply </Caption1>
																						</Button>
																					</StackItem>

																					<StackItem>
																						<Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
																							<Caption1> Cancel </Caption1>
																						</Button>
																					</StackItem>
																				</Stack>
																			</Stack>
																		</MenuList>
																	</>} />
															</StackItem>
															<StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true)}}>
																<Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
																	<Stack tokens={{ childrenGap: 5 }} horizontal>
																		<StackItem> <FilterDismiss20Filled /> </StackItem>
																		<StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
																	</Stack>
																</Button>
															</StackItem>
														</Stack>
														{(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
													</Stack>
													<Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
														<StackItem>
															{filterArray.length > 0 &&
																// <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
																<Stack wrap horizontal >
																	{filterArray.length > 0 && filterArray.map((item, index) => (
																		<Button shape="circular" size="small">
																			<Stack tokens={{ childrenGap: 5 }} horizontal>
																				<StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
																				<StackItem>
																					<Stack tokens={{ childrenGap: 1 }}>
																						<StackItem><Text></Text></StackItem>
																						<StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
																					</Stack>
																				</StackItem>
																			</Stack>
																		</Button>
																	))}
																	{/* </Stack> */}
																</Stack>}
														</StackItem>

														<StackItem disableShrink>
															{(tableData.length > 0 && !loading) && (
																totalRecords > 0 &&
																<Caption1>
																	Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
																</Caption1>
															)}
														</StackItem>
													</Stack>
												</StackItem>
												<InfoBar showSpaces={true} title={"Compliance Policy is the section where group policies are configured to ensure alignment with organizational standards and regulations."} />
											</StackItem>
											{loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
										</Stack>
									</StackItem>
								</Stack>
							</FluentProvider>
						</Stack>

						<OverLay
							overlayopen={overlayOpen}
							setOverlayOpen={setOverlayOpen}
							overlayData={automationOverLayData}
							saveBtnFunc={setSaveBtnClicked}
							saveBtnClicked={saveBtnClicked}
							isNavBtn={true}
							formRef={formRef}
							handleOutsideButton={handleOutsideButton}
							handleSubmit={handleSubmit}
							classificationNameValidation={classificationNameValidation}
						/>
						<OverLay
							overlayopen={overlayOpenNew}
							setOverlayOpen={setOverlayOpenNew}
							overlayData={overLayDataNew}
						/>
						
						{isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveBtnClicked && overlayName === '') ? "Policy Deleted Successfully" : (overlayName !== 'editAutomation') ? "New Policy Created Successfully" : "Policy Edited Successfully"} footer="" />}

						{errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}
						{refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
					</StackItem>
					</StackItem>
					{isCommonToast && (
							<ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent={message?.type} position="top-end" title={message?.type.charAt(0).toUpperCase() + message?.type.slice(1)} message={message?.text} footer="" />
						)}
					<StackItem><Text></Text></StackItem>
				</Stack>
			</FullScreen>
		</>
	);
};